import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
export default {
  name: "PlaneTurntableRender",
  props: {
    review: {
      type: Object,
      default: () => null
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      selectedColors: {}
    };
  },
  computed: {
    size() {
      return 260;
    },
    cx() {
      return this.size / 2;
    },
    cy() {
      return this.size / 2;
    },
    outerRadius() {
      return this.size * 0.46;
    },
    innerRadius() {
      return this.size * 0.28;
    },
    innerHole() {
      return this.size * 0.12;
    },
    iconSize() {
      return this.size * 0.045;
    },
    clueSize() {
      return 28;
    },
    answerableShapes() {
      return (this.data?.shapes || []).filter(shape => shape !== this.data?.clueShape);
    },
    selectableColors() {
      return (this.data?.colors || []).filter(color => color !== this.data?.clueColor);
    },
    outerSegments() {
      const colors = this.data?.colors || [];
      return colors.map((c, i) => {
        const seg = this.buildQuadrant(i, this.outerRadius);
        return {
          ...seg,
          color: this.colorMap[c] || c
        };
      });
    },
    innerSegments() {
      const shapes = this.data?.shapes || [];
      return shapes.map((s, i) => {
        const seg = this.buildQuadrant(i, this.innerRadius);
        return {
          ...seg,
          shape: s
        };
      });
    },
    colorMap() {
      return {
        Red: '#e74c3c',
        Green: '#27ae60',
        Blue: '#3498db',
        Yellow: '#f1c40f'
      };
    },
    colorLabelMap() {
      return {
        Red: '红色',
        Green: '绿色',
        Blue: '蓝色',
        Yellow: '黄色'
      };
    }
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler() {
        this.initSelections();
      }
    },
    review: {
      deep: true,
      handler() {
        this.initSelections();
      }
    }
  },
  methods: {
    initSelections() {
      if (this.reviewMode && this.review && this.isMappingAnswer(this.review.answer)) {
        this.selectedColors = this.parseAnswerMap(this.review.answer);
      } else {
        this.selectedColors = {};
      }
      this.emitAnswer();
    },
    chooseColor(shape, color) {
      if (this.reviewMode) {
        return;
      }
      const next = {
        ...this.selectedColors
      };
      if (next[shape] === color) {
        delete next[shape];
      } else {
        Object.keys(next).forEach(key => {
          if (next[key] === color) {
            delete next[key];
          }
        });
        next[shape] = color;
      }
      this.selectedColors = next;
      this.emitAnswer();
    },
    emitAnswer() {
      const answer = this.buildAnswerString(this.selectedColors);
      this.$emit('answer', answer);
    },
    buildAnswerString(answerMap) {
      if (!answerMap) {
        return null;
      }
      const pairs = this.answerableShapes.filter(shape => answerMap[shape]).map(shape => `${shape}-${answerMap[shape]}`);
      if (pairs.length !== this.answerableShapes.length) {
        return null;
      }
      return pairs.join(', ');
    },
    parseAnswerMap(answer) {
      const map = {};
      this.parseAnswerPairs(answer).forEach(pair => {
        map[pair.shape] = pair.color;
      });
      return map;
    },
    parseAnswerPairs(answer) {
      if (!answer || typeof answer !== 'string') {
        return [];
      }
      return answer.split(',').map(item => {
        const [shape, color] = item.split('-').map(part => (part || '').trim());
        return {
          shape,
          color
        };
      }).filter(pair => pair.shape && pair.color);
    },
    isMappingAnswer(answer) {
      return typeof answer === 'string' && answer.includes('-');
    },
    isColorDisabled(shape, color) {
      if (this.selectedColors[shape] === color) {
        return false;
      }
      return Object.keys(this.selectedColors).some(key => key !== shape && this.selectedColors[key] === color);
    },
    buildQuadrant(index, radius) {
      const centerDeg = this.quadrantCenters()[index] ?? 0;
      const centerRad = centerDeg * Math.PI / 180;
      const half = 45 * Math.PI / 180;
      const start = centerRad + half;
      const end = centerRad - half;
      const x1 = this.cx + radius * Math.cos(start);
      const y1 = this.cy + radius * Math.sin(start);
      const x2 = this.cx + radius * Math.cos(end);
      const y2 = this.cy + radius * Math.sin(end);
      const path = `M ${this.cx} ${this.cy} L ${x1} ${y1} A ${radius} ${radius} 0 0 0 ${x2} ${y2} Z`;
      const iconX = this.cx + radius * 0.65 * Math.cos(centerRad);
      const iconY = this.cy + radius * 0.65 * Math.sin(centerRad);
      return {
        index,
        path,
        iconX,
        iconY
      };
    },
    trianglePoints(x, y, r) {
      const p1 = `${x} ${y - r}`;
      const p2 = `${x - r} ${y + r}`;
      const p3 = `${x + r} ${y + r}`;
      return [p1, p2, p3].join(' ');
    },
    starPoints(cx, cy, outerR, innerR) {
      const points = [];
      for (let i = 0; i < 10; i++) {
        const r = i % 2 === 0 ? outerR : innerR;
        const a = Math.PI / 5 * i - Math.PI / 2;
        const x = cx + r * Math.cos(a);
        const y = cy + r * Math.sin(a);
        points.push(`${x} ${y}`);
      }
      return points.join(' ');
    },
    quadrantCenters() {
      return [135, 45, 315, 225];
    }
  }
};